<div class="h-100">
  @if (auftraege?.columns?.length) {
    <clr-datagrid #auftraegeDatagrid class="datagrid-compact h-100" [clrDgItemsIdentityFn]="row => row?.AuftragNr">
      @for (column of auftraege.columns; track column; let i = $index) {
        <clr-dg-column [clrDgField]="column.id">
          <ng-container
            *clrDgHideableColumn="{
              hidden: column.id | hideIDColumns: ['firmaid', 'parenttyp', 'parentstatus', 'ks_inttyp', 'ks_typid'],
            }">
            {{ column.id | mrTranslate | titlecase }}
          </ng-container>
        </clr-dg-column>
      }
      <ng-template
        clrVirtualScroll
        let-row
        [clrVirtualRowsOf]="auftraege.rows"
        [clrVirtualRowsTrackBy]="(_, row) => row?.AuftragNr">
        <clr-dg-row [clrDgItem]="row">
          @if (authservice?.token?.rights?.status > 1) {
            <clr-dg-action-overflow>
              <button class="action-item" (click)="openAuftrag(row)">
                {{ 'Auftrag öffnen' | mrTranslate }}
              </button>
            </clr-dg-action-overflow>
          }

          @for (cell of auftraege.columns; track cell) {
            <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
          }
        </clr-dg-row>
      </ng-template>
      <clr-dg-footer>
        <div>{{ auftraege.rows.length }} {{ 'Zeilen' | mrTranslate }}</div>
        <div class="d-f clr-justify-content-between clr-flex-wrap margin-10-tb">
          <span>
            <strong>{{ 'Kosten' | mrTranslate }}:</strong>
            <br />
            {{ (summen | async).kosten | currency: 'EUR' : 'symbol' : '1.2-2' }}
          </span>
          <span>
            <strong>{{ 'Plankosten' | mrTranslate }}:</strong>
            <br />
            {{ (summen | async).plankosten | currency: 'EUR' : 'symbol' : '1.2-2' }}
          </span>
          <span>
            <strong>{{ 'Personalstunden' | mrTranslate }} / {{ 'geplant' | mrTranslate }}:</strong>
            <br />
            {{ (summen | async).personalstunden | number: '1.2-3' : 'de' }} /
            {{ (summen | async).personalstundenPlanung | number: '1.2-3' : 'de' }}
          </span>
          <span>
            <strong>{{ 'Personalkosten' | mrTranslate }} / {{ 'geplant' | mrTranslate }}:</strong>
            <br />
            {{ (summen | async).typKosten['PERSONAL'] | currency: 'EUR' : 'symbol' : '1.2-2' }} /
            {{ (summen | async).typPlankosten[1] | currency: 'EUR' : 'symbol' : '1.2-2' }}
          </span>
          <span>
            <strong>{{ 'Fremdleistung' | mrTranslate }} / {{ 'geplant' | mrTranslate }}:</strong>
            <br />
            {{ (summen | async).typKosten['FREMDLEISTUNG'] | currency: 'EUR' : 'symbol' : '1.2-2' }} /
            {{ (summen | async).typPlankosten[4] | currency: 'EUR' : 'symbol' : '1.2-2' }}
          </span>
          <span>
            <strong>{{ 'Material' | mrTranslate }} / {{ 'geplant' | mrTranslate }}:</strong>
            <br />
            {{ (summen | async).typKosten['MATERIAL'] | currency: 'EUR' : 'symbol' : '1.2-2' }} /
            {{ (summen | async).typPlankosten[2] | currency: 'EUR' : 'symbol' : '1.2-2' }}
          </span>
          <span>
            <strong>{{ 'Maschinen' | mrTranslate }} / {{ 'geplant' | mrTranslate }}:</strong>
            <br />
            {{ (summen | async).typKosten['MASCHINE'] | currency: 'EUR' : 'symbol' : '1.2-2' }} /
            {{ (summen | async).typPlankosten[3] | currency: 'EUR' : 'symbol' : '1.2-2' }}
          </span>
        </div>
      </clr-dg-footer>
    </clr-datagrid>
  }
</div>
